import React from 'react'

import { Field } from 'formik'

import { Col, Form, Row, Button } from '_zari/core'

import * as ActivosFijosService from 'services/activosFijos.service'

import { TiposMovimientoActivo } from 'constants/index'

import { KeyEventUtil } from 'utils'
import { ZariContext } from '_zari/context'

import * as Modals from '../modals'

const ActivoFijoFormGroup = ({
  iError,
  iTouched,
  iCuentaContable,
  fIsSubmitting,
  handleChange,
  setFieldValue,
  fechaDocumento,
  activoFijoAnteriorData,
  setActivoFijoAnteriorData,
  centroCostoData
}) => {
  const [activosFijos, setActivosFijos] = React.useState([])
  const __zariContext = React.useContext(ZariContext)
  const [mostrarActivoFijoModal, setMostrarActivoFijoModal] = React.useState(false)
  const [activoFijoModalData, setActivoFijoModalData] = React.useState({})

  React.useEffect(() => {
    ActivosFijosService.getSelect({ cuenta: iCuentaContable })
      .then(({ data }) => {
        setActivosFijos(data)
      })
      .catch(() => setActivosFijos([]))
  }, [iCuentaContable])

  const clickNuevoActivoFijoModal = React.useCallback(() => {
    if (!fechaDocumento) {
      __zariContext.snack('error', 'Debe ingresar la fecha del documento.')
      return
    }
    setActivoFijoModalData({
      cuentaContable: iCuentaContable,
      fecha: fechaDocumento,
      depreciacionAnual: activoFijoAnteriorData.depreciacionAnual || '',
      _idCentroCostoNivel1: centroCostoData._idCentroCostoNivel1 || activoFijoAnteriorData._idCentroCostoNivel1 || '',
      _idCentroCostoNivel2: centroCostoData._idCentroCostoNivel2 || activoFijoAnteriorData._idCentroCostoNivel2 || '',
      centroCostoNivel1Info: centroCostoData.centroCostoNivel1Info || activoFijoAnteriorData.centroCostoNivel1Info || '',
      centroCostoNivel2Info: centroCostoData.centroCostoNivel2Info || activoFijoAnteriorData.centroCostoNivel2Info || '',
      cuentaContableDebe: activoFijoAnteriorData.cuentaContableDebe || '',
      cuentaContableDebeInfo: activoFijoAnteriorData.cuentaContableDebeInfo || '',
      cuentaContableHaber: activoFijoAnteriorData.cuentaContableHaber || '',
      cuentaContableHaberInfo: activoFijoAnteriorData.cuentaContableHaberInfo || ''
    })
    setMostrarActivoFijoModal(true)
  }, [__zariContext, fechaDocumento, iCuentaContable, activoFijoAnteriorData, centroCostoData])

  const onKeyDownPrimero = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-ActivoFijo', e)
  }, [])

  const refreshActivosFijos = React.useCallback(() => {
    ActivosFijosService.getSelect({ cuenta: iCuentaContable })
      .then(({ data }) => {
        setActivosFijos(data)
      })
      .catch(() => setActivosFijos([]))
  }, [iCuentaContable])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const matchedActivo = activosFijos.find(x => x._id === e.target.value)
      if (matchedActivo) {
        setFieldValue('activoFijoInfo', matchedActivo.nombre)
      } else {
        setFieldValue('activoFijoInfo', '')
      }
    },
    [handleChange, setFieldValue, activosFijos]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('nuevoasiento-agregar-button', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='ACTIVO FIJO' htmlFor='select-tipoMovimientoActivo' md={12} />
        <Col md={12}>
          <Row>
            <Col md={4}>
              <Field name='tipoMovimientoActivo'>
                {({ field }) => (
                  <Form.Select
                    {...field}
                    id='select-tipoMovimientoActivo'
                    isInvalid={iTouched && iError}
                    disabled={fIsSubmitting}
                    onKeyDown={onKeyDownPrimero}
                  >
                    <option value=''>Seleccionar</option>
                    <option value={TiposMovimientoActivo.SALDO_INICIAL}>1 Saldo Inicial</option>
                    <option value={TiposMovimientoActivo.ADICIONES}>2 Adiciones</option>
                    <option value={TiposMovimientoActivo.MEJORAS}>3 Mejoras</option>
                    <option value={TiposMovimientoActivo.RETIROS}>4 Retiros</option>
                    <option value={TiposMovimientoActivo.OTROS}>5 Otros</option>
                  </Form.Select>
                )}
              </Field>
            </Col>
            <Col md={6}>
              <Form.InputGroup>
                <Field name='_idActivoFijo'>
                  {({ field }) => (
                    <Form.Select
                      {...field}
                      id='select-ActivoFijo'
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting}
                      onChange={onChange}
                      onKeyDown={onKeyDown}
                    >
                      <option value=''>Seleccionar</option>
                      {activosFijos.map((x, k) => (
                        <option key={k} value={x._id}>
                          {x.nombre}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Field>
                <Form.InputGroup.Append>
                  <Button onClick={clickNuevoActivoFijoModal}>+</Button>
                </Form.InputGroup.Append>
              </Form.InputGroup>
            </Col>
          </Row>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarActivoFijoModal && (
        <Modals.ActivoFijoModal
          handleClose={() => setMostrarActivoFijoModal(false)}
          show={mostrarActivoFijoModal}
          modalData={activoFijoModalData}
          refreshActivosFijos={refreshActivosFijos}
          setActivoFijoAnteriorData={setActivoFijoAnteriorData}
        />
      )}
    </>
  )
}

export default React.memo(ActivoFijoFormGroup)
